import {
  Activity,
  AlertTriangle,
  CalendarClock,
  Calculator,
  Clock,
  Cog,
  Plug,
  Settings2,
} from 'lucide-react';

import { SubHubLayout } from '@/modulos/admin/parametrizacao/SubHubLayout';

/**
 * `/admin/configuracoes` — a porta de entrada das configurações
 * operacionais do sistema.
 *
 * Reusa `SubHubLayout`, o mesmo dos hubs de parametrização: cartão vira `<Link>`
 * só quando a rota de destino existe de fato, e o que ainda não foi construído
 * fica inerte com selo "Em construção" em vez de virar link morto (CLAUDE.md,
 * "Proibido": rota órfã).
 *
 * O protótipo trazia mais três destinos neste hub — Integrações, Busca global e
 * Página 404. Integrações já tem rota própria e entra aqui apontada; as outras
 * duas ainda não existem neste repositório e por isso não aparecem: cartão só se
 * justifica quando leva a algum lugar.
 */
export function ConfiguracoesHub() {
  return (
    <SubHubLayout
      titulo="Configurações"
      descricao="Parâmetros operacionais do sistema: prazos de fechamento, limites de alerta, ações em lote, trabalhos agendados e integrações externas."
      voltarPara="/admin"
      itens={[
        {
          titulo: 'Configurações gerais',
          descricao: 'Identidade visual do portal, metadados de busca e limites da inscrição.',
          icone: Cog,
          para: '/admin/configuracoes/gerais',
        },
        {
          titulo: 'Prazo de fechamento mensal',
          descricao: 'Dia limite do mês seguinte, distinto para pessoa física e jurídica.',
          icone: CalendarClock,
          para: '/admin/configuracoes/fechamento',
        },
        {
          titulo: 'Alerta de desvio do lote',
          descricao:
            'Percentual de variação contra o mês anterior que sinaliza desvio na aprovação.',
          icone: AlertTriangle,
          para: '/admin/configuracoes/desvio-alerta',
        },
        {
          titulo: 'Ateste de medição',
          descricao:
            'Limites de desvio de valor e de alunos, e a janela do histórico usada como referência.',
          icone: Calculator,
          para: '/admin/configuracoes/ateste',
        },
        {
          titulo: 'SLAs institucionais',
          descricao:
            'Os quatro prazos da apuração mensal, em dias úteis, iguais para todas as DREs.',
          icone: Clock,
          para: '/admin/configuracoes/slas',
        },
        {
          titulo: 'Matriz de ações em lote',
          descricao: 'Em quais etapas do fechamento cada ação em lote fica disponível.',
          icone: Settings2,
          para: '/admin/configuracoes/acoes-em-lote',
        },
        {
          titulo: 'Trabalhos agendados',
          descricao: 'Saúde das tarefas automáticas: última execução, próxima e falhas recentes.',
          icone: Activity,
          para: '/admin/configuracoes/agendamentos',
        },
        {
          titulo: 'Integrações',
          descricao: 'Conector gov.br e demais sistemas externos.',
          icone: Plug,
          para: '/admin/integracoes',
        },
      ]}
    />
  );
}

export default ConfiguracoesHub;
